<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>活动报名</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="活动">
          <el-select
            v-model="query.actid"
            placeholder="全部活动"
            clearable
            @change="selList"
            style="width: 160px;"
          >
            <el-option
              v-for="item in activityList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>活动报名</span>
        </div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column prop="activity.title" label="活动"></el-table-column>
          <el-table-column
            prop="wxUser.code"
            label="用户编号"
          ></el-table-column>
          <el-table-column
            prop="wxUser.nickName"
            label="用户昵称"
          ></el-table-column>
          <el-table-column prop="realName" label="姓名"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="weChat" label="微信号"></el-table-column>
          <el-table-column prop="joinCount" label="参加人数" width="90"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column label="报名状态">
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.state === 1
                    ? 'success'
                    : scope.row.state === 2
                    ? 'info'
                    : ''
                "
                size="small"
              >
                {{
                  scope.row.state === 1
                    ? "已报名"
                    : scope.row.state === 2
                    ? "已取消"
                    : "未知"
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="signupTime" label="报名时间">
            <template slot-scope="scope">
              {{ scope.row.signupTime || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="查看详情" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-view"
                    @click="viewClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- ========== 查看/新增对话框 ========== -->
    <el-dialog
      :title="dialogMode === 'view' ? '查看报名详情' : '添加报名用户'"
      :visible.sync="dialogVisible"
      @close="onDialogClose"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :disabled="dialogMode === 'view'"
      >
        <el-tabs type="card">
          <el-tab-pane label="基本信息">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="活动" prop="actitle">
                  <el-input v-model="form.actitle"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="用户昵称" prop="wxname">
                  <el-input v-model="form.wxname"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="微信号" prop="weChat">
                  <el-input v-model="form.weChat"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="参加人数" prop="joinCount">
                  <el-input v-model="form.joinCount"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="姓名" prop="realName">
                  <el-input
                    v-model="form.realName"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="联系方式" prop="mobile">
                  <el-input
                    v-model="form.mobile"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item prop="signupTime" label="报名时间">
                  <el-date-picker
                    v-model="form.signupTime"
                    type="datetime"
                    placeholder="选择报名时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24" v-if="dialogMode === 'view'">
              <el-col :span="12">
                <el-form-item label="报名状态">
                  <el-tag
                    :type="
                      form.state === 1
                        ? 'success'
                        : form.state === 2
                        ? 'info'
                        : ''
                    "
                    size="small"
                  >
                    {{
                      form.state === 1
                        ? "已报名"
                        : form.state === 2
                        ? "已取消"
                        : "未知"
                    }}
                  </el-tag>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="备注" prop="remark">
                  <el-input v-model="form.remark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";

export default {
  data() {
    return {
      query: {},
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {
        id: 0,
        activityID: "",
        userID: "",
        realName: "",
        mobile: "",
        weChat: "",
        joinCount: "",
        remark: "",
        signupTime: "",
        state: "",
        actitle: "",
        wxname: "",
      },
      dialogVisible: false,
      dialogMode: "add",
      activityList: [],
      userList: [],
    };
  },
  methods: {
    getList() {
      this.loading = true;
      const link = url.getActivity("GetListActjoin");
      $.get(
        link,
        {
          pageindex: this.currentPage4,
          pagesize: this.pageSize,
          key: this.query.key || "",
          actid: this.query.actid || "",
          memid: this.query.memid || "",
          state: this.query.state || "",
        },
        (res) => {
          this.loading = false;
          this.tableData = res.list || [];
          this.total = res.total || 0;
        },
      ).fail(() => {
        this.loading = false;
        this.$message.error("获取列表失败");
      });
    },
    selList() {
      this.currentPage4 = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    getAllAct() {
      const link = url.getActivity("GetAllAct");
      $.get(link, {}, (res) => {
        console.log("完整返回:", res);
        console.log("第一条数据:", res[0]);
        console.log("第一条数据的键名:", Object.keys(res[0]));
        this.activityList = res || [];
      });
    },
    getAllUser() {
      const link = url.getActivity("GetAllUser");
      $.get(link, {}, (res) => {
        this.userList = res || [];
      });
    },
    viewClick(row) {
      this.dialogMode = "view";
      this.form = {
        id: row.id,
        activityID: row.activityID,
        userID: row.userID,
        realName: row.realName,
        mobile: row.mobile,
        weChat: row.weChat || "",
        joinCount: row.joinCount != null ? row.joinCount : "",
        remark: row.remark,
        signupTime: row.signupTime,
        state: row.state,
        actitle: row.activity ? row.activity.title : "",
        wxname: row.wxUser ? row.wxUser.nickName : "",
      };
      this.dialogVisible = true;
    },
    delClick(row) {
      this.$confirm("确定要删除该报名记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const link = url.getActivity("DeleteActjoin");
          $.post(link, { id: row.id }, (res) => {
            if (res.status) {
              this.$message.success(res.msg);
              this.getList();
            } else {
              this.$message.error(res.msg || "删除失败");
            }
          });
        })
        .catch(() => {});
    },
    onDialogClose() {
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
  },
  mounted() {
    this.getList();
    this.getAllAct();
    this.getAllUser();
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}

.el-form-item--small.el-form-item {
  margin-right: 0px;
}

.el-button--primary {
  margin-left: 10px;
}
</style>
